// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { MenuDivider } from '../Menu';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `ListActionsDivider` component is a part of [ListActions](#!/ListActions) component.
 * It accepts the props of [MenuDivider](#!/MenuDivider) component.
 * @since 3.10.0
 */
const ListActionsDivider = props => /*#__PURE__*/_jsx(MenuDivider, {
  ...props
});
export default ListActionsDivider;